module.exports = __webpack_public_path__ + "static/preview-shoutcart-06ca4e0893f7af18e7f5a96dc17e246d.png";